import React, { Suspense, lazy } from 'react';
import Menu from '../Menu/Menu';
import GoogleMapsReviews from '../Reviews/GoogleMapsReviews';
import HeaderComponent from '../HeaderComponent/HeaderComponent';
import WaveDivider from '../WaveDivider/WaveDivider';
import Footer from '../Footer/Footer';
import PriceList from '../PriceList/PriceList';
import { colors } from '../../theme/tokens';

const LocationMap = lazy(async () => await import('../LocationMap/LocationMap'));

const HomePage: React.FC = () => {
  return (
    <div>
      <Menu />
      <section className="heroSection" aria-label="Best Groom Studio">
        <HeaderComponent />
      </section>
      <WaveDivider
        fillColor={colors.cream}
        backgroundColor={colors.sectionLight}
      />
      <section className="light">
        <GoogleMapsReviews />
      </section>
      <WaveDivider
        fillColor={colors.sectionLight}
        backgroundColor={colors.cream}
      />
      <section className="cream">
        <PriceList />
      </section>
      <WaveDivider
        fillColor={colors.cream}
        backgroundColor={colors.sectionLight}
      />
      <section className="light" id="howToFindId">
        <Suspense
          fallback={
            <p className="py-10 text-center text-muted">Loading map…</p>
          }
        >
          <LocationMap />
        </Suspense>
      </section>
      <Footer />
    </div>
  );
};

export default HomePage;
